module.exports = __webpack_public_path__ + "static/img/icon_tv.811d21d8.svg";